import Link from 'next/link';
import { ImageText } from '../image-text/image-text';
import type { ImageTextProps } from '../image-text/image-text';

type ImageLinkProps = {
    href: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
} & ImageTextProps;

export const ImageTextLink = ({ href, onClick, ...props }: ImageLinkProps) => {
    return (
        <Link href={href} prefetch={false} onClick={onClick}>
            <ImageText {...props} />
        </Link>
    );
};
